"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote, Star } from "lucide-react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious, type CarouselApi } from "@/components/ui/carousel";
import { Button } from "@/components/ui/button";
const testimonials = [{
  author: "Jane D.",
  quote: "Quick, reliable, and paid cash on the spot! Highly recommend Junk Car Pick Up BC.",
  position: "Vancouver customer"
}, {
  author: "Mike S.",
  quote: "They picked up my damaged car the same day and offered a great price. Very professional service.",
  position: "Burnaby customer"
}];
export default function WhatOurClientsSay() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap() + 1);
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap() + 1);
    });
  }, [api]);
  return <section id="what-our-clients-say" className="dark bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-[500px] bg-primary/5 blur-[120px] rounded-full pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-6 text-foreground">
            What Our Clients Say
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl">
            Real reviews from real customers across British Columbia. See why we are the trusted choice for fast, reliable junk car removal.
          </p>
        </div>

        <div className="max-w-5xl mx-auto relative">
          <Carousel setApi={setApi} opts={{
          align: "start",
          loop: true
        }} className="w-full">
            <CarouselContent className="-ml-4 md:-ml-6">
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i} className="pl-4 md:pl-6 md:basis-1/2">
                  <div className="p-1 h-full">
                    <Card className="bg-card border-border/30 shadow-xl rounded-[5px] h-full flex flex-col relative overflow-hidden group hover:border-primary/50 transition-colors duration-300">
                      {}
                      <Quote className="absolute top-6 right-6 size-24 text-primary/5 rotate-180 transition-transform duration-500 group-hover:scale-110 group-hover:text-primary/10" />
                      
                      <CardHeader className="pb-4 relative z-10">
                        <div className="flex items-center gap-4 mb-4">
                          <SafeHydrate><Avatar className="size-14 border-2 border-primary/20 rounded-[5px]">
                            <AvatarFallback className="bg-primary/10 text-primary font-bold text-lg rounded-[5px]">
                              {testimonial.author.charAt(0)}
                            </AvatarFallback>
                          </Avatar></SafeHydrate>
                          <div>
                            <div className="font-bold text-card-foreground text-lg">
                              {testimonial.author}
                            </div>
                            <div className="text-sm text-primary font-medium">
                              {testimonial.position}
                            </div>
                          </div>
                        </div>
                        <div className="flex gap-1">
                          {[...Array(5)].map((_, starIndex) => <Star key={starIndex} data-index={starIndex} className="size-5 fill-primary text-primary" />)}
                        </div>
                      </CardHeader>
                      <CardContent className="relative z-10 flex-grow">
                        <p className="text-muted-foreground text-lg leading-relaxed italic">
                          "{testimonial.quote}"
                        </p>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            {}
            <div className="hidden md:block">
              <CarouselPrevious className="bg-primary text-primary-foreground hover:bg-primary/90 border-none size-12 -left-16 shadow-lg rounded-[5px]" />
              <CarouselNext className="bg-primary text-primary-foreground hover:bg-primary/90 border-none size-12 -right-16 shadow-lg rounded-[5px]" />
            </div>
          </Carousel>

          {}
          <div className="flex justify-center gap-3 mt-10">
            {Array.from({
            length: count
          }).map((_, i) => <Button key={i} data-index={i} variant="ghost" size="icon" className={`size-3 rounded-full p-0 min-h-0 min-w-0 transition-all duration-300 ${i === current - 1 ? "bg-primary w-8" : "bg-primary/20 hover:bg-primary/50"}`} onClick={() => api?.scrollTo(i)} aria-label={`Go to slide ${i + 1}`} />)}
          </div>
        </div>
      </div>
    </section>;
}